import React from 'react';
import ControlPanel from './components/ControlPanel/ControlPanel';
import Tabs from './components/Tabs/Tabs';
import CronGeneratorResult from './components/CronGeneratorResult/CronGeneratorResult';

const Generator: React.FC = () => {
	return (
		<>
			<ControlPanel />
			<Tabs />
			<CronGeneratorResult />
		</>
	);
};

export default Generator;
